import React from 'react';
import {
    ClusterNumberFieldEdit,
} from '@domain/dashboard/cluster/campaign-table-cluster-components/cluster-number-field-edit';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

interface MinimumPerformanceValueEdit {
    value: number
    row: any
}

export const MinimumPerformanceValueEdit = ({
    value,
    row,
}: MinimumPerformanceValueEdit) => (
    <ClusterNumberFieldEdit
        row={row}
        value={value}
        key={CLUSTER_FIELDS_FUNCTIONS.minimumPerformanceValue.field}
        field={CLUSTER_FIELDS_FUNCTIONS.minimumPerformanceValue.field}
        type={METRICS_TYPES.string}
        precision={2}
    />
);
